import { TranslationKey, translationKey } from 'intl/types/translationKey';

/**
 * AUTO-GENERATED — do not edit manually.
 * Run `yarn generate:translation-keys` after changing messages.en.json.
 */
export const ReportTranslationKeys = {
  buttonDownloadLabel: translationKey('pdf_button_download_label'),
  buttonGeneratingPDFLabel: translationKey('pdf_button_generatingPDF_label'),
  buttonPrintLabel: translationKey('pdf_button_print_label'),
  costTotal: translationKey('pdf_cost_total'),
  eventFileName: translationKey('pdf_event_file_name'),
  eventFooterText: translationKey('pdf_event_footer_text'),
  eventNcrEventCreatedBy: translationKey('pdf_event_ncr_event_created_by'),
  eventNcrEventCreationDate: translationKey('pdf_event_ncr_event_creation_date'),
  eventNcrLabel: translationKey('pdf_event_ncr_label'),
  eventReferToIssueLabel: translationKey('pdf_event_refer_to_issue_label'),
  fileNameField: translationKey('pdf_file_name_field'),
  footerPageInfo: translationKey('pdf_footer_page_info'),
  headerAttachments: translationKey('pdf_header_attachments'),
  headerIssueCreationDate: translationKey('pdf_header_issue_creation_date'),
  headerIssueDetectionDate: translationKey('pdf_header_issue_detection_date'),
  headerIssueLevel: translationKey('pdf_header_issue_level'),
  headerOtherAttachments: translationKey('pdf_header_other_attachments'),
  headerPictures: translationKey('pdf_header_pictures'),
  issueNumberLabel: translationKey('pdf_issue_number_label'),
  issueReportTitle: translationKey('pdf_issue_report_title'),
  ncrHeader: translationKey('pdf_ncr_header'),
  signatureFieldApprovedBy: translationKey('pdf_signature_field_approvedBy'),
  signatureFieldDate: translationKey('pdf_signature_field_date'),
  signatureFieldSignature: translationKey('pdf_signature_field_signature'),
  accordionInspectionData: translationKey('report_accordion_inspection_data'),
  accordionIssueData: translationKey('report_accordion_issue_data'),
  accordionReportParts: translationKey('report_accordion_report_parts'),
  accordionTemplateData: translationKey('report_accordion_template_data'),
  additionalContentEmpty: translationKey('report_additional_content_empty'),
  attachmentsScopeAll: translationKey('report_attachments_scope_all'),
  attachmentsScopeAllTooltip: translationKey('report_attachments_scope_all_tooltip'),
  attachmentsScopeMain: translationKey('report_attachments_scope_main'),
  attachmentsScopeMainTooltip: translationKey('report_attachments_scope_main_tooltip'),
  attachmentsToggleLabel: translationKey('report_attachments_toggle_label'),
  displayStyleFullA4: translationKey('report_display_style_full_a4'),
  displayStyleFullA4Tooltip: translationKey('report_display_style_full_a4_tooltip'),
  displayStyleList: translationKey('report_display_style_list'),
  displayStyleListTooltip: translationKey('report_display_style_list_tooltip'),
  displayStyleMiniatures: translationKey('report_display_style_miniatures'),
  displayStyleMiniaturesTooltip: translationKey('report_display_style_miniatures_tooltip'),
  estimatedReportSizeBadge: translationKey('report_estimated_report_size_badge'),
  estimatedReportSizeBadgeSplit: translationKey('report_estimated_report_size_badge_split'),
  fieldContentAllFields: translationKey('report_field_content_all_fields'),
  fieldContentLabel: translationKey('report_field_content_label'),
  fieldContentOnlyFieldsWithValue: translationKey('report_field_content_only_fields_with_value'),
  fieldContentOnlySelectedFields: translationKey('report_field_content_only_selected_fields'),
  fileInfoChipActiveLinks: translationKey('report_file_info_chip_active_links'),
  fileInfoChipActiveLinksTooltip: translationKey('report_file_info_chip_active_links_tooltip'),
  fileInfoChipDescriptions: translationKey('report_file_info_chip_descriptions'),
  fileInfoChipDescriptionsTooltip: translationKey('report_file_info_chip_descriptions_tooltip'),
  fileInfoChipNames: translationKey('report_file_info_chip_names'),
  fileInfoChipNamesTooltip: translationKey('report_file_info_chip_names_tooltip'),
  fileInfoChipPhoneNumbers: translationKey('report_file_info_chip_phone_numbers'),
  fileInfoChipPhoneNumbersTooltip: translationKey('report_file_info_chip_phone_numbers_tooltip'),
  fileInfoChipUserEmails: translationKey('report_file_info_chip_user_emails'),
  fileInfoChipUserEmailsTooltip: translationKey('report_file_info_chip_user_emails_tooltip'),
  inspectionControlledElementAttachments: translationKey('report_inspection_controlled_element_attachments'),
  inspectionShowNotApplicable: translationKey('report_inspection_show_not_applicable'),
  inspectionShowUnchecked: translationKey('report_inspection_show_unchecked'),
  issueAdditionalContent: translationKey('report_issue_additional_content'),
  issueHustroLinks: translationKey('report_issue_hustro_links'),
  linkExpiredInfo: translationKey('report_link_expired_info'),
  linkToHustro: translationKey('report_link_to_hustro'),
  linkToHustroTooltip: translationKey('report_link_to_hustro_tooltip'),
  messageAttachmentsDisabledEvents: translationKey('report_message_attachments_disabled_events'),
  messageAttachmentsDisabledIncomingEmailMessages: translationKey('report_message_attachments_disabled_incoming_email_messages'),
  messageAttachmentsDisabledWorkflowDecisions: translationKey('report_message_attachments_disabled_workflow_decisions'),
  messageForReport: translationKey('report_message_for_report'),
  messageIncludeInPdfLabel: translationKey('report_message_include_in_pdf_label'),
  messageIncludeInPdfTooltip: translationKey('report_message_include_in_pdf_tooltip'),
  messageKindDisabledEvents: translationKey('report_message_kind_disabled_events'),
  messageKindDisabledIncomingEmailMessages: translationKey('report_message_kind_disabled_incoming_email_messages'),
  messageKindDisabledWorkflowDecisions: translationKey('report_message_kind_disabled_workflow_decisions'),
  partChecklist: translationKey('report_part_checklist'),
  partInspectionData: translationKey('report_part_inspection_data'),
  partIssueRegister: translationKey('report_part_issue_register'),
  partSignatureSpace: translationKey('report_part_signature_space'),
  partSummary: translationKey('report_part_summary'),
  participantPersonalDataLabel: translationKey('report_participant_personal_data_label'),
  sectionAdditionalInformation: translationKey('report_section_additional_information'),
  sectionContent: translationKey('report_section_content'),
  sectionDisabledEventsSingle: translationKey('report_section_disabled_events_single'),
  sectionDisabledIncomingEmailMessagesSingle: translationKey('report_section_disabled_incoming_email_messages_single'),
  sectionDisabledInspectionControlledElementAttachments: translationKey('report_section_disabled_inspection_controlled_element_attachments'),
  sectionDisabledInspectionControlledElementStandard: translationKey('report_section_disabled_inspection_controlled_element_standard'),
  sectionDisabledInspectionControlledElementStandardAttachments: translationKey('report_section_disabled_inspection_controlled_element_standard_attachments'),
  sectionDisabledInspectionGeneralStandard: translationKey('report_section_disabled_inspection_general_standard'),
  sectionDisabledInspectionGeneralStandardAttachments: translationKey('report_section_disabled_inspection_general_standard_attachments'),
  sectionDisabledInspectionIssueRegister: translationKey('report_section_disabled_inspection_issue_register'),
  sectionDisabledInspectionSectionAttachments: translationKey('report_section_disabled_inspection_section_attachments'),
  sectionDisabledInspectionSectionDescriptions: translationKey('report_section_disabled_inspection_section_descriptions'),
  sectionDisabledIssueAttachments: translationKey('report_section_disabled_issue_attachments'),
  sectionDisabledIssueAttachmentsSingle: translationKey('report_section_disabled_issue_attachments_single'),
  sectionDisabledLinkedDocumentation: translationKey('report_section_disabled_linked_documentation'),
  sectionDisabledLinkedDocumentationSingle: translationKey('report_section_disabled_linked_documentation_single'),
  sectionDisabledParentChecklist: translationKey('report_section_disabled_parent_checklist'),
  sectionDisabledParentIssueData: translationKey('report_section_disabled_parent_issue_data'),
  sectionDisabledParentTemplateData: translationKey('report_section_disabled_parent_template_data'),
  sectionDisabledWorkflowDecisionsSingle: translationKey('report_section_disabled_workflow_decisions_single'),
  sectionEventsLabel: translationKey('report_section_events_label'),
  sectionIncomingEmailMessagesLabel: translationKey('report_section_incoming_email_messages_label'),
  sectionIssueAttachmentsLabel: translationKey('report_section_issue_attachments_label'),
  sectionLinkedDocumentationLabel: translationKey('report_section_linked_documentation_label'),
  sectionReportContent: translationKey('report_section_report_content'),
  sectionWorkflowDecisionsLabel: translationKey('report_section_workflow_decisions_label'),
  selectedFieldsLabel: translationKey('report_selected_fields_label'),
  suboptionAttachmentsScope: translationKey('report_suboption_attachments_scope'),
  suboptionDisplayStyle: translationKey('report_suboption_display_style'),
  templateControlledElementStandard: translationKey('report_template_controlled_element_standard'),
  templateControlledElementStandardAttachments: translationKey('report_template_controlled_element_standard_attachments'),
  templateGeneralStandard: translationKey('report_template_general_standard'),
  templateGeneralStandardAttachments: translationKey('report_template_general_standard_attachments'),
  templateSectionAttachments: translationKey('report_template_section_attachments'),
  templateSectionDescriptions: translationKey('report_template_section_descriptions'),
  wizardStepContent: translationKey('report_wizard_step_content'),
  sendReportLabelMessage: translationKey('send_report_label_message'),
  sendReportLabelName: translationKey('send_report_label_name'),
  sendReportLabelTo: translationKey('send_report_label_to'),
  sendReportLanguage: translationKey('send_report_language'),
  columnAssignee: translationKey('workbook_column_assignee'),
  columnCreatedBy: translationKey('workbook_column_created_by'),
  columnCreationDate: translationKey('workbook_column_creation_date'),
  columnDetectionDate: translationKey('workbook_column_detection_date'),
  columnIssueNumber: translationKey('workbook_column_issue_number'),
  columnModifiedAtDate: translationKey('workbook_column_modifiedAt_date'),
  columnOrderNumber: translationKey('workbook_column_orderNumber'),
  columnOutstandingCost: translationKey('workbook_column_outstanding_cost'),
  columnPhoto: translationKey('workbook_column_photo'),
  columnReportTitle: translationKey('workbook_column_reportTitle'),
  columnResolutionPhoto: translationKey('workbook_column_resolution_photo'),
  columnSettledCost: translationKey('workbook_column_settled_cost'),
  couldNotDownloadPhotosError: translationKey('workbook_could_not_download_photos_error'),
  generatedFileName: translationKey('workbook_generated_file_name'),
  labelIssues: translationKey('workbook_label_issues'),
  notificationError: translationKey('workbook_notification_error'),
  timezoneInfo: translationKey('workbook_timezone_info'),
} as const satisfies Record<string, TranslationKey>;
